import api from './axios';

// Publisher content upload (any file type — stored for admin review)
export const publisherContentUploadApi = (formData) =>
  api.post('/uploads/content/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const getPublisherContentApi = (params) =>
  api.get('/uploads/content/list/', { params });

export const downloadPublisherContentApi = (id) =>
  api.get(`/uploads/content/${id}/download/`, { responseType: 'blob' });

export const adminPublishContentApi = (id, data) =>
  api.post(`/uploads/content/${id}/publish/`, data);

// Legacy admin direct upload (Excel/CSV → books immediately)
export const adminUploadApi = (formData) =>
  api.post('/uploads/admin/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const getUploadHistoryApi = (params) => api.get('/uploads/history/', { params });

export const downloadUploadedFileApi = (id) =>
  api.get(`/uploads/history/${id}/download/`, { responseType: 'blob' });

export const downloadTemplateApi = () =>
  api.get('/uploads/template/', { responseType: 'blob' });
